import {css} from 'lit';
export const styles = css`:host {
  --link-text: var(--primary-200);
  --link-text-hover: var(--contrast-light);
  --link-text-active: var(--primary-000);

  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  z-index: 800;
}

  @media (min-width: 768px) {:host {
    left: auto;
    left: initial;
    top: calc(var(--page-header-height) + var(--page-padding-bottom));
    width: var(--page-aside-width);
    bottom: auto
}

    :host slot::slotted(*:not(:last-child)) {
      margin-bottom: 6px;
    }
  }

nav {
  display: grid;
  grid-template-rows: 1fr;
  grid-template-columns: repeat(5, 20%);
  grid-gap: 0;
  gap: 0;
  height: var(--page-nav-height);
  background-color: var(--primary);
}

@media (min-width: 768px) {

nav {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    height: auto;
    padding: 16px;
    background-color: var(--gray-200);
    border-radius: var(--border-radius)
}
  }
`;
export default styles;
